export default __webpack_public_path__ + "static/media/s2s_header.af4b0d20.jpg";